// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__67W1w","rootSmall":"AddTileButton_rootSmall__3nxWV"};